// extracted by mini-css-extract-plugin
export var deliveryRow = "_kx-a";
export var fixedHeight = "_kx-4";
export var freightLogo = "_kx-9";
export var fullWidth = "_kx-3";
export var priceColumn = "_kx-5";
export var radioSelected = "_kx-7";
export var radioUnselected = "_kx-6";
export var selectedOption = "_kx-2";
export var selectedOptionContainer = "_kx-1";
export var selection = "_kx-0";
export var tallSkeletonText = "_kx-8";